import { TERMS_AR } from "./terms.ar";
import { TERMS_EN } from "./terms.en";
import { TERMS_EXTRA_AR } from "./terms.extra.ar";
import { TERMS_EXTRA_EN } from "./terms.extra.en";
import { PRIVACY_AR } from "./privacy.ar";
import { PRIVACY_EN } from "./privacy.en";
import { PRIVACY_EXTRA_AR } from "./privacy.extra.ar";
import { PRIVACY_EXTRA_EN } from "./privacy.extra.en";
import { EULA_AR } from "./eula.ar";
import { EULA_EN } from "./eula.en";
import { BIOMETRIC_AR } from "./biometric.ar";
import { BIOMETRIC_EN } from "./biometric.en";
import { DELETION_AR } from "./deletion.ar";
import { DELETION_EN } from "./deletion.en";
import { STORE_BILLING } from "./terms.billing";
import { IS_STORE_BUILD } from "../../config/storeBuild";

export const LEGAL_VERSION = "2.2";

// نسخة المتاجر: يُستبدل بند الاشتراك بنص «لا مشتريات داخل التطبيق» (آبل 3.1.3(c)).
const billing = (sections, lang) =>
  IS_STORE_BUILD ? sections.map((s) => (s.id === "billing" ? STORE_BILLING[lang] : s)) : sections;

const merge = (doc, extra, lang) => ({
  ...doc,
  version: LEGAL_VERSION,
  updated: "2026-06-18",
  sections: billing([...doc.sections, ...extra], lang),
});

const DOCS = {
  terms: { ar: merge(TERMS_AR, TERMS_EXTRA_AR, "ar"), en: merge(TERMS_EN, TERMS_EXTRA_EN, "en") },
  privacy: { ar: merge(PRIVACY_AR, PRIVACY_EXTRA_AR, "ar"), en: merge(PRIVACY_EN, PRIVACY_EXTRA_EN, "en") },
  eula: { ar: EULA_AR, en: EULA_EN },
  biometric: { ar: BIOMETRIC_AR, en: BIOMETRIC_EN },
  deletion: { ar: DELETION_AR, en: DELETION_EN },
};

export const LEGAL_KINDS = Object.keys(DOCS);

export const legalDoc = (kind, lang) => {
  const doc = DOCS[kind] || DOCS.terms;
  return doc[lang === "ar" ? "ar" : "en"];
};
